import React, { useRef, useEffect } from 'react';
import { StyleSheet, View, Platform, StyleProp, ViewStyle } from 'react-native';

type Props = {
  style?: StyleProp<ViewStyle>;
};

const PlaceholderLoader = (props: Props) => {
  const viewRef = useRef<View>(null);

  useEffect(() => {
    if (Platform.OS === 'web' && document) {
      viewRef.current?.setNativeProps({
        className: 'rnw-placeholder-loader',
      });

      if (!document.querySelector(`[data-name="rnw-placeholder-loader"]`)) {
        const style = document.createElement('style');

        style.setAttribute('data-name', 'rnw-placeholder-loader');
        style.textContent = `.rnw-placeholder-loader {
          position: absolute;
          left: -45%;
          height: 100%;
          width: 45%;
          background-image: linear-gradient(to left, rgba(28, 28, 28, 0.00), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.00));
          background-image: -moz-linear-gradient(to left, rgba(28, 28, 28, 0.00), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.00));
          background-image: -webkit-linear-gradient(to left, rgba(28, 28, 28, 0.00), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.015), rgba(28, 28, 28, 0.00));
          animation: rnw-placeholder-loader 1s infinite;
          z-index: 45;
        } @keyframes rnw-placeholder-loader {
          0%{
            left: -45%;
          }
          100%{
            left: 100%;
          }
        }`;

        document.head.appendChild(style);
      }
    }
  }, []);

  return (
    <View style={[styles.wrapper, props.style]}>
      <View style={styles.root} ref={viewRef} />
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(28, 28, 28, 0.1)',
    overflow: 'hidden',
  },
  root: {
    flex: 1,
    alignItems: 'center',
  },
});

export default PlaceholderLoader;
